import { Link, useNavigate } from "react-router";

const Header: React.FC<{
  toggleMenu: () => void;
  showBackButton?: boolean;
  isLoggedIn: boolean;
  toggleNotificationsPanel: () => void;
  notifications: boolean;
}> = ({
  toggleMenu,
  isLoggedIn,
  showBackButton,
  toggleNotificationsPanel,
  notifications,
}) => {
  const navigate = useNavigate();
  return (
    <header className="fixed flex justify-between items-center box-border py-4 px-5 bg-[#fff] dark:bg-bg-dark lg:hidden w-full z-20">
      {showBackButton ? (
        <button onClick={() => navigate(-1)} type="button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.243"
            height="13.501"
            viewBox="0 0 20.243 13.501"
          >
            <path
              id="Icon_ionic-ios-arrow-round-back"
              data-name="Icon ionic-ios-arrow-round-back"
              d="M15.216,11.51a.919.919,0,0,1,.007,1.294l-4.268,4.282H27.218a.914.914,0,0,1,0,1.828H10.955L15.23,23.2a.925.925,0,0,1-.007,1.294.91.91,0,0,1-1.287-.007L8.142,18.647h0a1.026,1.026,0,0,1-.19-.288.872.872,0,0,1-.07-.352.916.916,0,0,1,.26-.64l5.794-5.836A.9.9,0,0,1,15.216,11.51Z"
              transform="translate(-7.882 -11.252)"
              className="fill-jiwe-dark-blue dark:fill-grey-light"
            />
          </svg>
        </button>
      ) : (
        <div className="flex gap-2 -mr-[1.8rem]">
          <Link to="/profile" onClick={() => toggleMenu()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="text-jiwe-dark-blue dark:text-grey-light"
            >
              <path
                d="M12,.563a12,12,0,1,0,12,12A12,12,0,0,0,12,.563Zm0,4.645A4.258,4.258,0,1,1,7.742,9.466,4.258,4.258,0,0,1,12,5.208Zm0,16.645a9.272,9.272,0,0,1-7.089-3.3,5.4,5.4,0,0,1,4.766-2.894,1.184,1.184,0,0,1,.344.053A6.407,6.407,0,0,0,12,16.046a6.382,6.382,0,0,0,1.979-.334,1.184,1.184,0,0,1,.344-.053,5.4,5.4,0,0,1,4.766,2.894A9.272,9.272,0,0,1,12,21.853Z"
                transform="translate(0 -0.563)"
                className="fill-jiwe-dark-blue dark:fill-grey-light"
              />
            </svg>
          </Link>
          {isLoggedIn && (
            <button
              className="border-0 p-0 m-0 bg-[transparent] relative"
              id="view-notifications"
              type="button"
              onClick={() => toggleNotificationsPanel()}
            >
              {notifications && (
                <span className="absolute top-0 right-0 w-2 h-2 bg-jiwe-alt-yellow rounded-full" />
              )}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.75}
                stroke="currentColor"
                className="text-jiwe-dark-blue dark:text-grey-light size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
                />
              </svg>
            </button>
          )}
        </div>
      )}
      <Link to="/">
        <img src="/assets/logo.png" alt="logo" className="h-[3rem]" />
      </Link>
      <button type="button" onClick={() => toggleMenu()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="13.5"
          viewBox="0 0 18 13.5"
        >
          <g id="Group_2" data-name="Group 2" transform="translate(0 0.75)">
            <g id="Group_1" data-name="Group 1">
              <line
                id="Line_6"
                data-name="Line 6"
                x1="18"
                fill="none"
                strokeWidth="2"
                className="stroke-jiwe-dark-blue dark:stroke-grey-light"
              />
              <line
                id="Line_5"
                data-name="Line 5"
                x1="14"
                transform="translate(4 6)"
                fill="none"
                strokeWidth="2"
                className="stroke-jiwe-dark-blue dark:stroke-grey-light"
              />
              <line
                id="Line_4"
                data-name="Line 4"
                x1="18"
                transform="translate(0 12)"
                fill="none"
                strokeWidth="2"
                className="stroke-jiwe-dark-blue dark:stroke-grey-light"
              />
            </g>
          </g>
        </svg>
      </button>
    </header>
  );
};

export default Header;
